import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './App.css';
import { I18nProvider } from '@lingui/react';
import { messages as bgMessages } from './locales/bg/messages'
import { messages as enMessages } from './locales/en/messages'
import { i18n } from '@lingui/core'
import { en, bg } from 'make-plural/plurals'
import { useMemo } from 'react';
import { TourProvider } from './contexts/tour-context';
import MapScene from './components/map/map-scene.component';

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        retry: 0
      },
    },
  });

  useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    let lang = params.get('lang');
    i18n.loadLocaleData({
      bg: { plurals: bg },
      en: { plurals: en },
    })
    i18n.load({
      bg: bgMessages,
      en: enMessages,
    })

    if (lang && lang === 'en') {
      i18n.activate('en')
    } else {
      i18n.activate('bg')
    }
  }, [])

  return (
    <>
      <I18nProvider i18n={i18n}>
        <QueryClientProvider client={queryClient}>
          <TourProvider>
            <MapScene />
          </TourProvider>
        </QueryClientProvider>
      </I18nProvider>
    </>
  );
}

export default App;
